module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-69.9a441e12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-69.jpg
// module id = 4028
// module chunks = 13